import { images } from "./siteData";

export const investorPresentationSlides = [
  {
    number: "01",
    eyebrow: "GAMEDAY Holdings Strategic Overview",
    title: "A PLATFORM FOR PERFORMANCE, READINESS, AND PROGRESS.",
    copy:
      "GAMEDAY Holdings is building an integrated development vision across human "
      + "performance, immersive readiness, recovery science, and intelligence systems.",
    points: ["One connected holding-company platform", "Two differentiated future divisions"],
    image: images.performance,
  },
  {
    number: "02",
    eyebrow: "The opportunity",
    title: "HIGH-STAKES PREPARATION REMAINS FRAGMENTED.",
    copy:
      "Athletes, teams, research partners, and mission-focused organizations often manage "
      + "training, data, recovery, simulation, and facilities as disconnected systems.",
    points: ["Disconnected performance infrastructure", "Limited integrated environments"],
  },
  {
    number: "03",
    eyebrow: "The GAMEDAY platform",
    title: "CONNECT THE FULL PERFORMANCE CYCLE.",
    copy:
      "The GAMEDAY model brings preparation, measurement, simulation, recovery, research, "
      + "and collaboration into intentional, adaptable environments.",
    points: ["Physical infrastructure plus intelligence", "Shared capabilities across markets"],
  },
  {
    number: "04",
    eyebrow: "Division one",
    title: "PERFORMANCE WORLD.",
    copy:
      "A proposed destination ecosystem for athletes, teams, researchers, technology partners, "
      + "and next-generation sports performance programming.",
    points: [
      "Training and sports science",
      "Recovery and team operations",
      "Innovation collaboration",
    ],
    image: images.performance,
  },
  {
    number: "05",
    eyebrow: "Division two",
    title: "MILITARY PERFORMANCE CENTER.",
    copy:
      "A proposed readiness environment linking environmental preparation, immersive simulation, "
      + "human performance, recovery, and after-action learning.",
    points: [
      "Adaptive simulation concepts",
      "Tactical human performance",
      "Resilience and readiness",
    ],
    image: images.military,
  },
  {
    number: "06",
    eyebrow: "Technology layer",
    title: "MAKE ENVIRONMENTS MORE INTELLIGENT.",
    copy:
      "GAMEDAY is exploring technology across movement analysis, data systems, immersive "
      + "environments, smart-facility operations, and performance review.",
    points: [
      "Performance data architecture",
      "Immersive scenario design",
      "Smart-facility concepts",
    ],
  },
  {
    number: "07",
    eyebrow: "Strategic opportunity",
    title: "BUILD DURABLE, MULTI-CHANNEL VALUE.",
    copy:
      "The long-range platform may connect programming, strategic relationships, real estate, "
      + "research, licensing, destination operations, and technology-enabled services.",
    points: ["Multiple relationship pathways", "Phased development flexibility"],
  },
  {
    number: "08",
    eyebrow: "Capital strategy",
    title: "ALIGN CAPITAL TO PROVEN PROGRESS.",
    copy:
      "The company intends to pursue a phased approach to validation, pilot operations, flagship "
      + "development, and expansion—subject to final agreements, approvals, and diligence.",
    points: ["Qualitative, milestone-led approach", "No valuation or offer is presented"],
  },
  {
    number: "09",
    eyebrow: "Development path",
    title: "MOVE FROM CONCEPT TO CONNECTED CAMPUSES.",
    copy:
      "Current work centers on strategy, feasibility, relationships, concepts, and the conditions "
      + "for future pilot and flagship development.",
    points: ["Foundation and validation", "Pilot operations", "Flagship development and expansion"],
  },
  {
    number: "10",
    eyebrow: "Next step",
    title: "SHAPE THE NEXT ERA OF HUMAN PERFORMANCE.",
    copy:
      "GAMEDAY invites qualified investors and strategic collaborators to begin a confidential, "
      + "diligence-led discussion around aligned future opportunities.",
    points: ["Investor dialogue", "Strategic collaboration", "Long-term alignment"],
  },
];